(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rcc-full-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
 if(root.dataset.ready) return;
 root.dataset.ready='true';
 const track=root.querySelector('.rcc-weekly__track'),status=root.querySelector('[data-status]');
 let next=root.dataset.next,loading=null,failed=false,frame=0;
 function count(){
  if(failed||loading)return;
  const cards=Array.from(track.children);
  if(!cards.length)return;
  const box=track.getBoundingClientRect();
  const visible=cards.map((card,i)=>({i,rect:card.getBoundingClientRect()})).filter(x=>x.rect.right>box.left+4&&x.rect.left<box.right-4);
  if(visible.length)status.textContent=(visible[0].i+1)+'–'+(visible[visible.length-1].i+1)+' / '+root.dataset.total;
 }
 async function more(){
  if(loading)return loading;
  if(!next)return true;
  failed=false;
  status.textContent=root.querySelector('[data-loading]').textContent;
  loading=(async()=>{
   try{
    const url=new URL(next,window.location.origin);
    url.searchParams.set('section_id',root.dataset.section);
    const preview=new URLSearchParams(window.location.search).get('preview_theme_id');
    if(preview)url.searchParams.set('preview_theme_id',preview);
    const response=await fetch(url.toString(),{credentials:'same-origin'});
    if(!response.ok)throw new Error('Request failed');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const incoming=doc.querySelector('[data-rcc-weekly]');
    if(!incoming)throw new Error('Missing section');
    const known=new Set(Array.from(track.children).map(c=>c.dataset.productId));
    const cards=Array.from(incoming.querySelectorAll('.rcc-weekly__card')).filter(c=>!known.has(c.dataset.productId));
    if(!cards.length)throw new Error('No new products');
    track.append(...cards);
    next=incoming.dataset.next;
    return true;
   }catch(error){
    failed=true;
    status.textContent=root.querySelector('[data-error]').textContent;
    return false;
   }finally{loading=null;count();}
  })();
  return loading;
 }
 track.addEventListener('scroll',()=>{
  cancelAnimationFrame(frame);
  frame=requestAnimationFrame(()=>{
   count();
   if(!failed&&next&&track.scrollLeft+track.clientWidth*3>=track.scrollWidth)more();
  });
 },{passive:true});
 root.querySelector('[data-next-button]').addEventListener('click',async()=>{
  const atEnd=track.scrollLeft+track.clientWidth>=track.scrollWidth-8;
  if(next&&(failed||track.scrollLeft+track.clientWidth*2>=track.scrollWidth)){
   if(!await more())return;
  }else if(atEnd&&!next){track.scrollTo({left:0,behavior:'smooth'});return;}
  track.scrollBy({left:track.clientWidth+parseFloat(getComputedStyle(track).gap),behavior:'smooth'});
 });
 root.querySelector('[data-prev]').addEventListener('click',()=>{
  track.scrollBy({left:-track.clientWidth-parseFloat(getComputedStyle(track).gap),behavior:'smooth'});
 });
 new ResizeObserver(count).observe(track);
 count();
}
function all(scope){scope.querySelectorAll('[data-rcc-weekly]').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>all(document));else all(document);
document.addEventListener('shopify:section:load',e=>all(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
